import { z } from 'zod'

import {
  labelAndValue,
  paginationSchema,
  sortingSchema,
  roomType
} from '@/utils/zod'

export const roomFiltersSchema = z.object({
  id: z.array(labelAndValue()).optional(),
  type: z.array(roomType).optional(),
  ...paginationSchema.shape,
  ...sortingSchema.shape
})
